import axios from 'axios';

import { env } from 'config';
import {
  P2PProvider,
  P2PProviderLastOrderData,
  P2PProviderTradeMethods,
} from 'types';

import { createCrudApi } from './crud.api';

const url = `${env.apiUrl}/p2p-providers`;

const getLastTakenOrderAt = async (
  id: string,
): Promise<P2PProviderLastOrderData> =>
  (await axios.get(`${url}/${id}/last-taken-order-at`)).data;

const getTradeMethods = async (): Promise<P2PProviderTradeMethods[]> =>
  (await axios.get(`${url}/trade-methods`)).data;

export const p2pProvidersApi = {
  ...createCrudApi<P2PProvider>('/p2p-providers'),
  getLastTakenOrderAt,
  getTradeMethods,
};
